import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpEvent,
  HttpErrorResponse,
  HttpEventType,
  HttpRequest,
} from '@angular/common/http';
import { environment } from '../../../../environments/environment.prod';
import { Observable, Observer, fromEvent, merge, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
  });

  baseUrl: string = environment.backend;

  constructor(private http: HttpClient) { }

  createUser(fg): Observable<any> {
    return this.http.post(
      this.baseUrl + 'users/users-v1/',
      fg,
      this.getAuthHeaders()
    );
  }

  updateUser(fg): Observable<any> {
    return this.http.put(
      this.baseUrl + 'users/users-v1/',
      fg,
      this.getAuthHeaders()
    );
  }

  actionUser(fg): Observable<any> {
    return this.http.post(
      this.baseUrl + 'users/users-v1/',
      fg,
      this.getAuthHeaders()
    );
  }

  readAllUsers(): Observable<any> {
    return this.http.get(
      this.baseUrl + 'users/users-v1/',
      this.getAuthHeaders()
    );
  }

  readOrgUsers1(org_id, sub_id): Observable<any> {
    return this.http.get(
      this.baseUrl + 'users/users-v1/?organization_id=' + org_id + '&&subscription_id=' + sub_id,
      this.getAuthHeaders()
    );
  }

  readOrgUsers(org_id, sub_id, offset, limit): Observable<any> {
    return this.http.get(
      this.baseUrl + 'users/users-v1/?organization_id=' + org_id + '&&subscription_id=' + sub_id + '&&offset=' + offset + '&&limit=' + limit,
      this.getAuthHeaders()
    );
  }


  searchOrgSubUsers(org_id, sub_id, offset, limit, query_string): Observable<any> {
    return this.http.get(
      this.baseUrl +
      'users/users-v1/?organization_id=' + org_id + '&&subscription_id=' + sub_id + '&&offset=' +
      offset +
      '&limit=' +
      limit +
      '&keyword=' +
      query_string,
      this.getAuthHeaders()
    );
  }

  // getUserAccountList(offset, limit): Observable<any> {
  //   return this.http.get(
  //     this.baseUrl + 'accounts/userinfo/?offset=' + offset + '&limit=' + limit,
  //     this.getAuthHeaders()
  //   );
  // }

  searchAccountList(offset, limit, query_string): Observable<any> {
    return this.http.get(
      this.baseUrl +
      'accounts/userinfo/?offset=' +
      offset +
      '&limit=' +
      limit +
      '&keyword=' +
      query_string,
      this.getAuthHeaders()
    );
  }


  readUserAccessRoles(sub_id): Observable<any> {
    return this.http.get(
      this.baseUrl + 'users/get_user_types/?subscription_id=' + sub_id,
      this.getAuthHeaders()
    );
  }

  createDepartmentInfo(fg): Observable<any> {
    return this.http.post(
      this.baseUrl + 'accounts/teams/',
      fg,
      this.getAuthHeaders()
    );
  }




  getUserDepartmentList(org_id): Observable<any> {
    return this.http.get(
      this.baseUrl + 'accounts/teams/?organization_id=' + org_id,
      this.getAuthHeaders()
    );
  }



  deleteUserDepartmentList(fg): Observable<any> {
    return this.http.post(
      this.baseUrl + 'accounts/teams/',
      fg,
      this.getAuthHeaders()
    );
  }


  logoutConcurrentUser(fg): Observable<any> {
    return this.http.post(
      this.baseUrl + 'accounts/logout/',
      fg,
      this.getAuthHeaders()
    );
  }

  getXlsxSampleFile(): Observable<any> {
    return this.http.get(
      this.baseUrl +
      'users/get_dynamic_bulk_excel/',
      this.getAuthHeaders()
    );
  }

  readOrgWiseUser(org_id: number): Observable<any> {
    return this.http.get(
      this.baseUrl + 'users/users/?offset=0&number=500&organization_id=' + org_id,
      this.getAuthHeaders()
    );
  }

  addUserToTeam(team_id: number): Observable<any> {
    const formData = new FormData();
    formData.append('team_id', team_id.toString());
    return this.http.post(this.baseUrl + 'accounts/add-user-to-team/', formData, this.getAuthHeaders());
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('token');
    const httpHeaders = new HttpHeaders({ Authorization: 'Token ' + token });

    return { headers: httpHeaders };
  }
}
